import FingerprintJS from "@fingerprintjs/fingerprintjs";

const generateDeviceId = async () => {
  //const fp = await getDeviceId();
  const fp = await FingerprintJS.load({
    token: "gRFbO46GhIYEf0AI5z16",
  });

  const { visitorId } = await fp.get();

  // Get the visitor identifier
  //const visitorId = result.visitorId;

  return visitorId;
};

export { generateDeviceId };
